export const FASTSHIFT_LOCALSTORAGE_KEYS = {
    SELECTED_ORG_ID: "fastshift-selected-org"
};

export const NO_ORG_ID = "no-org";

export enum DROPDOWN_ORG_ID {
    NO_ORG = "no-org",
    OTHER_ORGS = "other-orgs"
}
